// src/data/mockEvents.js
export const mockEvents = [
  {
    id: 1,
    type: "incident",
    severity: "high",
    title: "Network Outage",
    description: "Fiber cut reported near downtown. Affecting ~500 users.",
    lat: 40.7128,
    lng: -74.006,
    timestamp: "2024-01-15T08:23:00Z",
    status: "active",
    assignee: "Team Alpha",
  },
  {
    id: 2,
    type: "asset",
    severity: "low",
    title: "CCTV Unit #A47",
    description: "Surveillance camera operational. Last ping 2 mins ago.",
    lat: 40.7282,
    lng: -73.7949,
    timestamp: "2024-01-15T09:00:00Z",
    status: "operational",
    assignee: "Security Ops",
  },
  {
    id: 3,
    type: "iot",
    severity: "medium",
    title: "Temperature Sensor",
    description: "Server room temp: 28°C. Approaching threshold (30°C).",
    lat: 40.6892,
    lng: -74.0445,
    timestamp: "2024-01-15T09:15:00Z",
    status: "warning",
    assignee: "Facilities",
  },
  {
    id: 4,
    type: "incident",
    severity: "critical",
    title: "Unauthorized Access Attempt",
    description: "Multiple failed login attempts detected at east gate.",
    lat: 40.7489,
    lng: -73.968,
    timestamp: "2024-01-15T07:45:00Z",
    status: "active",
    assignee: "Security Team",
  },
  {
    id: 5,
    type: "asset",
    severity: "low",
    title: "Mobile Unit #B12",
    description: "Patrol vehicle en route. Battery: 82%.",
    lat: 40.7614,
    lng: -73.9776,
    timestamp: "2024-01-15T09:30:00Z",
    status: "operational",
    assignee: "Field Ops",
  },
  {
    id: 6,
    type: "iot",
    severity: "high",
    title: "Flood Sensor Alert",
    description: "Water level rising in basement area B3. Immediate action required.",
    lat: 40.7041,
    lng: -74.0131,
    timestamp: "2024-01-15T09:10:00Z",
    status: "active",
    assignee: "Maintenance",
  },
  {
    id: 7,
    type: "incident",
    severity: "medium",
    title: "Traffic Congestion",
    description: "Major slowdown on Main Ave due to road works.",
    lat: 40.7831,
    lng: -73.9712,
    timestamp: "2024-01-15T08:50:00Z",
    status: "monitoring",
    assignee: "Traffic Control",
  },
  {
    id: 8,
    type: "asset",
    severity: "low",
    title: "Power Substation #7",
    description: "Substation running normally. Load at 67%.",
    lat: 40.6782,
    lng: -73.9442,
    timestamp: "2024-01-15T09:00:00Z",
    status: "operational",
    assignee: "Power Grid",
  },
  {
    id: 9,
    type: "iot",
    severity: "low",
    title: "Air Quality Sensor",
    description: "AQI: 42 (Good). CO2 levels within normal range.",
    lat: 40.7549,
    lng: -74.0022,
    timestamp: "2024-01-15T09:20:00Z",
    status: "operational",
    assignee: "Environment",
  },
  {
    id: 10,
    type: "incident",
    severity: "high",
    title: "Power Fluctuation",
    description: "Voltage spikes reported in Grid Zone 4. Investigating.",
    lat: 40.7228,
    lng: -73.9875,
    timestamp: "2024-01-15T08:40:00Z",
    status: "active",
    assignee: "Power Team",
  },
];

export const eventTypes = ["all", "incident", "asset", "iot"];
export const severityLevels = ["all", "critical", "high", "medium", "low"];
export const statusOptions = ["all", "active", "operational", "warning", "monitoring"];
